import React from 'react'
import { styled } from '@mui/material/styles'
import { AppBar, Toolbar, Menu, MenuItem } from '@mui/material'
import MoreIcon from '@mui/icons-material/MoreVert'
import ThemeConfig from './../../theme/ThemeConfig'
import PropTypes from 'prop-types'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import Button from './../Button/Button'

const PREFIX = 'BulkActionBar'

const classes = {
  root: `${PREFIX}-root`,
  appBar: `${PREFIX}-appBar`,
  denseAppBar: `${PREFIX}-denseAppBar`,
  grow: `${PREFIX}-grow`,
  selectedTextStyle: `${PREFIX}-selectedTextStyle`,
  actionDiv: `${PREFIX}-actionDiv`,
}

const Root = styled('div')({
  [`& .${classes.root}`]: {},
  [`& .${classes.appBar}`]: {
    top: 'auto',
    bottom: 0,
    backgroundColor: ThemeConfig.palette.primary.main,
    zIndex: 3,
  },
  [`& .${classes.denseAppBar}`]: {
    maxHeight: '48px',
  },
  [`& .${classes.grow}`]: {
    flexGrow: 1,
  },
  [`& .${classes.selectedTextStyle}`]: {
    fontSize: ThemeConfig.typography.h1.fontSize,
    color: ThemeConfig.palette.background.paper,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  [`& .${classes.actionDiv}`]: {
    overflow: 'hidden',
  },
})

const verticalLine = {
  borderRight: '1px solid ' + ThemeConfig.palette.background.paper,
  height: '24px',
}

const BulkActionBar = props => {
  const { selectedCount, actionLimit, children } = props
  const bulkActionItems = []
  let actionCounter = 1
  const overFlowActionItems = []
  !children.length //children is not an array if only one action is passed
    ? bulkActionItems.push(children)
    : children.forEach(child => {
        if (actionLimit && actionCounter > actionLimit) {
          const actionProps = {}
          const handleOverFlowActionClick = () => {
            handleClose()
            if (child.props.onClick) {
              child.props.onClick()
            }
          }
          actionProps.onClick = handleOverFlowActionClick
          actionProps.key = child.props.id
          actionProps.value = child.props.actionName
          actionProps.disabled = child.props.disabled
          overFlowActionItems.push(
            <MenuItem {...actionProps}>
              {child.props.iconTag || ''} {child.props.actionName || ''}
            </MenuItem>,
          )
        } else {
          bulkActionItems.push(child)
        }
        actionCounter++
      })

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <Root>
      <AppBar
        position={props.static ? 'static' : 'fixed'}
        color="primary"
        className={classes.appBar}
      >
        <Toolbar
          variant="dense"
          disableGutters={true}
          classes={{ dense: classes.denseAppBar }}
        >
          <span className={classes.selectedTextStyle}>
            {selectedCount} Selected
          </span>
          {bulkActionItems}
          {actionLimit ? (
            <React.Fragment>
              <div style={verticalLine} />
              <Button
                variant="text"
                color="tertiary"
                bulkActions={true}
                toolTip="More Actions"
                onClick={handleClick}
              >
                <MoreIcon />
                MORE
              </Button>
              <Menu
                id="overflow-menu"
                keepMounted
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                {overFlowActionItems}
              </Menu>
            </React.Fragment>
          ) : (
            <div />
          )}
        </Toolbar>
      </AppBar>
    </Root>
  )
}

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  selectedCount: PropTypes.number,
  selectionLabel: PropTypes.string.isRequired,
}

export default BulkActionBar
